module.exports = __webpack_public_path__ + "img/document-active.5bc8ccbb.svg";